// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules_linux/css-loader/index.js??ref--6-1!../../../node_modules_linux/postcss-loader/lib/index.js??ref--6-2!./fonts.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules_linux/vue-style-loader/lib/addStylesClient.js")("67256040", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fonts.css
// module id = ku4k
// module chunks = 40